<div class="">
  <div *ngIf="isStructuredBlock">
    <div>        
      <div *ngFor="let block of _model.blocks; let i = index" class="relative p-3">
        <div>
          <div *ngIf="block.type == 'dialog'">
            <app-dialog-viewer [model]="block" [languages]="languages" [defaultLang]="defaultLang" [characters]="characters"></app-dialog-viewer>
          </div>
          <div *ngIf="block.type == 'media'">
            <app-media-viewer [model]="block" [languages]="languages" [defaultLang]="defaultLang"></app-media-viewer>
          </div>
          <div *ngIf="block.type == 'text'">
            <multilang-editor [model]="block.data" [readonly]="true"
              [languages]="languages" [defaultLang]="defaultLang"></multilang-editor>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="p-3" *ngIf="!isStructuredBlock">
    <div *ngIf="templateAttr && templateAttr[languages[0]]" [innerHTML]='getDiffAttributes(templateAttr[languages[0]], _model[languages[0]])'></div>
    <div *ngIf="!templateAttr || !templateAttr[languages[0]]" [innerHTML]='_model[languages[0]]'></div>
  </div>

</div>